// 引入图片
const imageUrl = (name: string): string => {
  return new URL(
    `../../../assets/image/recharge/way/${name}.png`,
    import.meta.url
  ).href
}

export const country = [
  // { text: "Indonesia", icon: '',value: 'ID' },
  // { text: "Malaysia", icon: '',value: 'MY' },
  { text: 'Indonesia', icon: '', value: 'ID' },
  { text: 'Malaysia', icon: '', value: 'MY' },
  { text: 'Egypt', icon: '', value: 'EG' },
  { text: 'Saudi Arabia', icon: '', value: 'SA' },
  { text: 'India', icon: '', value: 'IN' },
  { text: 'United Arab Emirates', icon: '', value: 'AE' },
  { text: 'Bahrain', icon: '', value: 'BH' },
  // { text: "Jordan", icon: '',value: 'JO' },
  { text: 'Kuwait', icon: '', value: 'KW' },
  { text: 'Qatar', icon: '', value: 'QA' },
  // { text: "Oman", icon: '',value: 'OM' },
  // { text: "Lebanon", icon: '',value: 'LB' },
  { text: 'Turkey', icon: '', value: 'TR' },
  { text: 'Vietnam', icon: '', value: 'VN' },
  { text: 'Philippines', icon: '', value: 'PH' },
  { text: 'Pakistan', icon: '', value: 'PK' },
  { text: 'Brazil', icon: '', value: 'BR' },
  { text: 'Mexico', icon: '', value: 'MX' },
  { text: 'Colombia', icon: '', value: 'CO' },
  { text: 'Peru', icon: '', value: 'PE' },
  { text: 'Chile', icon: '', value: 'CL' },
  { text: 'Uruguay', icon: '', value: 'UY' },
  { text: 'Paraguay', icon: '', value: 'PY' },
  { text: 'Argentina', icon: '', value: 'AR' },
  { text: 'America', icon: '', value: 'US' },
  { text: 'Iraq', icon: '', value: 'IQ' }
]

export const payWay = {
  ID: [
    {
      text: 'OVO',
      imgurl: imageUrl('ovo_icon'),
      paymentType: 'A36'
    },
    {
      text: 'DANA',
      imgurl: imageUrl('dana_icon'),
      paymentType: 'A7'
    },
    {
      text: 'Doku',
      imgurl: imageUrl('DOKU_ID'),
      paymentType: 'A1'
    },
    {
      text: 'LinkAja',
      imgurl: imageUrl('LinkAja_ID'),
      paymentType: 'A35'
    },
    // { text: "Akulaku", imgurl: imageUrl('Akulaku'), paymentType: 'AKULAKU' },
    {
      text: 'ShopeePAY',
      imgurl: imageUrl('ShopeePay_ID'),
      paymentType: 'SHOPEEPAY'
    },
    {
      text: 'Bank Transfer',
      imgurl: imageUrl('C0_Bank_Transfer'),
      paymentType: 'A18'
    },
    {
      text: 'Gopay',
      imgurl: imageUrl('gopay_icon'),
      paymentType: 'A2'
    },
    // { text: "BCA", imgurl:imageUrl('BCA_ID'), paymentType: 'A18' },
    // { text: "BRI", imgurl:imageUrl('BRI_ID'), paymentType: 'A18' },
    // { text: "BNI", imgurl:imageUrl('BNI_ID'), paymentType: 'A18' },
    // { text: "CIMB", imgurl:imageUrl('CIMB_ID'), paymentType: 'A18' },
    // { text: "Mandiri", imgurl:imageUrl('Mandiri_ID'), paymentType: 'A18' },
    // { text: "Danamon", imgurl:imageUrl('Danamon_ID'), paymentType: 'A18' },
    // { text: "Maybank", imgurl:imageUrl('Maybank_ID'), paymentType: 'A18' },
    // { text: "Permata", imgurl:imageUrl('Permata_ID'), paymentType: 'A18' },
    // { text: "Sinarmas", imgurl:imageUrl('Sinarmas_ID'), paymentType: 'A18' },
    {
      text: 'Alfamart',
      imgurl: imageUrl('Alfamart_ID'),
      paymentType: 'A11'
    }
  ],
  MY: [
    {
      text: 'Touch’n Go',
      imgurl: imageUrl("Touch'n_Go_MY"),
      paymentType: 'A43'
    },
    // { text: "Boost", imgurl: imageUrl("Axiata_Boost_MY"), paymentType: 'A40' },
    {
      text: 'Grabpay',
      imgurl: imageUrl('grabpay'),
      paymentType: 'A39'
    },
    {
      text: 'Maybank QR',
      imgurl: imageUrl('Maybank_MY'),
      paymentType: 'A41'
    }
  ],
  EG: [
    {
      text: 'Visa/Master Card',
      imgurl: imageUrl('B0_Card'),
      paymentType: 'A34'
    },
    // { text: 'Fawry', imgurl: imageUrl("Fawry_EG"), paymentType: 'A47' },
    // { text: 'Aman/Masary', imgurl:  imageUrl("Aman_Masary_EG"), paymentType: 'AMAN' },
    // { text: 'Mobile Wallets', imgurl:  imageUrl("Wallet"), paymentType: 'WALLETS' },
    {
      text: 'Vodafone',
      imgurl: imageUrl('Vodafone_EG'),
      paymentType: 'VODAFONE'
    }
    // { text: 'Orange', imgurl: imageUrl("Orange_EG"), paymentType: 'ORANGE' },
    // { text: 'We', imgurl:  imageUrl("We_EG"), paymentType: 'WE' },
  ],
  SA: [
    {
      text: 'Visa/Master Card',
      imgurl: imageUrl('B0_Card'),
      paymentType: 'A34'
    },
    {
      text: 'Mada',
      imgurl: imageUrl('MADA_SA'),
      paymentType: 'MADA'
    },
    { text: 'STCPAY', imgurl: imageUrl('stc_pay_ME'), paymentType: 'STCPAY' }
    // { text: "Zain", imgurl: imageUrl("zain_BH"), paymentType: 'Zain' },
  ],
  IN: [
    {
      text: 'UPI_CB',
      imgurl: imageUrl('UPI_IN'),
      paymentType: 'CUPI'
    },
    {
      text: 'all wallet',
      imgurl: imageUrl('A0_E-Wallet'),
      paymentType: 'CPTM'
    },
    {
      text: 'PhonePe',
      imgurl: imageUrl('PhonePe_IN'),
      paymentType: 'CPTM'
    },
    {
      text: 'Mobikwik',
      imgurl: imageUrl('Mobikwik'),
      paymentType: 'CPTM'
    },
    {
      text: 'Airtel money',
      imgurl: imageUrl('Airtel_Money_IN'),
      paymentType: 'CPTM'
    },
    {
      text: 'OLA money',
      imgurl: imageUrl('Ola_Money_IN'),
      paymentType: 'CPTM'
    },
    {
      text: 'Reliance Jiomoney',
      imgurl: imageUrl('Jio_Money_IN'),
      paymentType: 'CPTM'
    },
    {
      text: 'Net Banking_CB',
      imgurl: imageUrl('C2_Net_Banking'),
      paymentType: 'CNB'
    }
  ],
  AE: [
    {
      text: 'Visa Card',
      imgurl: imageUrl('B0_Card'),
      paymentType: 'A34'
    },
    {
      text: 'Mastercard	',
      imgurl: imageUrl('B0_Card'),
      paymentType: 'A34'
    },
    {
      text: 'Etisalat	',
      imgurl: imageUrl('Etisalat'),
      paymentType: 'A15'
    }
    // { text: "DU	", imgurl: imageUrl('DU_AE'), paymentType: 'DU' },
  ],
  BH: [
    // { text: "Visa Card", imgurl:  imageUrl('B0_Card'), paymentType: 'A34' },
    // { text: "Mastercard	", imgurl: imageUrl('B0_Card'),  paymentType: 'A34' },
    {
      text: 'Benefit	',
      imgurl: imageUrl('Benefit_BH'),
      paymentType: 'A46'
    }
    // { text: "Zain", imgurl: imageUrl('zain_BH'), paymentType: 'Zain' },
  ],
  JO: [
    // { text: "Visa Card", imgurl: imageUrl('B0_Card'), paymentType: 'A34' },
    // { text: "Mastercard", imgurl: imageUrl('B0_Card'), paymentType: 'A34' },
  ],
  KW: [
    {
      text: 'Visa/Master Card',
      imgurl: imageUrl('B0_Card'),
      paymentType: 'A34'
    },
    {
      text: 'KNET',
      imgurl: imageUrl('KNET_KW'),
      paymentType: 'A44'
    }
    // { text: "Zain", imgurl: imageUrl('zain_BH'), paymentType: 'Zain' },
  ],
  QA: [
    {
      text: 'Visa/Master Card',
      imgurl: imageUrl('B0_Card'),
      paymentType: 'A34'
    }
  ],
  OM: [
    // { text: "Visa Card", imgurl: imageUrl('B0_Card'), paymentType: 'A34' },
    // { text: "Mastercard", imgurl: imageUrl('B0_Card'), paymentType: 'A34' },
  ],
  LB: [
    // { text: "Visa Card", imgurl: imageUrl('B0_Card'), paymentType: 'A34' },
    // { text: "Mastercard", imgurl: imageUrl('B0_Card'), paymentType: 'A34' },
  ],
  TR: [
    {
      text: 'Troy Card',
      imgurl: imageUrl('troy'),
      paymentType: 'TROY'
    },
    {
      text: 'Visa Card',
      imgurl: imageUrl('B0_Card'),
      paymentType: 'TROY'
    },
    {
      text: 'Mastercard',
      imgurl: imageUrl('B0_Card'),
      paymentType: 'TROY'
    },
    {
      text: 'All Bank Transfer',
      imgurl: imageUrl('C0_Bank_Transfer'),
      paymentType: 'A18'
    },
    // { text: "İşbank", imgurl: imageUrl('isbank_TR'), paymentType: 'A18' },
    // { text: "Akbank", imgurl: imageUrl('Akbank_TR'), paymentType: 'A18' },
    // { text: "DenizBank", imgurl: imageUrl('DenizBank_TR'), paymentType: 'A18' },
    // { text: "Finansbank", imgurl: imageUrl('Finansbank_TR'), paymentType: 'A18' },
    // { text: "Halkbank", imgurl: imageUrl('Halkbank_TR'), paymentType: 'A18' },
    // { text: "PTT", imgurl: imageUrl('PTT_TR'), paymentType: 'A18' },
    // { text: "Türk Ekonomi Bankası", imgurl: imageUrl('Turk_Ekonomi_Bankasl_TR'), paymentType: 'A18' },
    // { text: "VakıfBank", imgurl: imageUrl('VaklfBank_TR'), paymentType: 'A18' },
    // { text: "Yapı Kredi", imgurl: imageUrl('Yapl_Kredi_TR'), paymentType: 'A18' },
    // { text: "Ziraat Bank", imgurl: imageUrl('Ziraat_Bank_TR'), paymentType: 'A18' },
    {
      text: 'BKM Express',
      imgurl: imageUrl('BKM_Express_TR'),
      paymentType: 'BKMEXPRESS'
    },
    {
      text: 'GPay Wallet',
      imgurl: imageUrl('GPay_Wallet_TR'),
      paymentType: 'GPAYWALLET'
    },
    {
      text: 'GPay EPin',
      imgurl: imageUrl('GPay_Wallet_TR'),
      paymentType: 'GPAYEPIN'
    },
    {
      text: 'Ininal',
      imgurl: imageUrl('Ininal_TR'),
      paymentType: 'ININAL'
    }
    // { text: "Mobile payment", imgurl: imageUrl('D0_Carrier_Billing'), paymentType: 'MOBILEPAYMENT' },
  ],
  VN: [
    {
      text: 'NganLuong Account',
      imgurl: imageUrl('Nganluong_VN'),
      paymentType: 'NGANLUONG'
    },
    // { text: "MoMo", imgurl: imageUrl('MoMo_VN'), paymentType: 'MOMO' },
    // { text: "ZaloPay", imgurl: imageUrl('Zalo_VN'), paymentType: 'ZALOPAY' },
    {
      text: 'Internet Banking',
      imgurl: imageUrl('C2_Net_Banking'),
      paymentType: '1002'
    },
    {
      text: 'Bank Transfer',
      imgurl: imageUrl('C0_Bank_Transfer'),
      paymentType: '1003'
    },
    {
      text: 'ATM Online',
      imgurl: imageUrl('B0_Card'),
      paymentType: '1010'
    },
    {
      text: 'ATM Offline',
      imgurl: imageUrl('C1_OTC_Banks'),
      paymentType: '1011'
    },
    {
      text: 'Bank Counter',
      imgurl: imageUrl('C1_OTC_Banks'),
      paymentType: '1012'
    }
  ],
  PH: [
    // { text: "Wallet", imgurl: imageUrl('A0_E-Wallet'), paymentType: 'EWALLET' },
    {
      text: 'GCash',
      imgurl: imageUrl('GCash_PH'),
      paymentType: 'A4'
    },
    {
      text: 'Grabpay',
      imgurl: imageUrl('grabpay'),
      paymentType: 'A39'
    },
    {
      text: 'Paymaya',
      imgurl: imageUrl('Paymaya_PH'),
      paymentType: 'PAYMAYA'
    },
    {
      text: 'DragonPay Credit',
      imgurl: imageUrl('DragonPay_Credit_PH'),
      paymentType: 'A38'
    }
  ],
  PK: [
    // { text: "Easypaisa", imgurl: imageUrl('Easypaisa_PK'), paymentType: 'EASYPAISA' },
    {
      text: 'Visa/MasterCard',
      imgurl: imageUrl('B0_Card'),
      paymentType: 'A34'
    }
    // { text: "JazzCash", imgurl: imageUrl('Jazz_Cash_PK'), paymentType: 'JAZZCASH' },
  ],
  BR: [
    {
      text: 'Credit Card',
      imgurl: imageUrl('B1_Credit_Card'),
      paymentType: '20'
    },
    {
      text: 'Bank Transfer',
      imgurl: imageUrl('C0_Bank_Transfer'),
      paymentType: '03'
    },
    // { text: "Itau", imgurl: imageUrl('Itau_BR'), paymentType: 'Itau' },
    // { text: "Bradesco", imgurl: imageUrl('Bradesco_BR'), paymentType: 'Bradesco' },
    // { text: "Banco do Brasil", imgurl: imageUrl('Banco_do_Brasil_BR'), paymentType: 'BB' },
    // { text: "Caixa", imgurl: imageUrl('Caixa_BR'), paymentType: 'Caixa' },
    // { text: "Santander", imgurl: imageUrl('Santander_BR'), paymentType: 'Santander' },
    {
      text: 'PIX',
      imgurl: imageUrl('PIX_BR'),
      paymentType: 'PIX'
    },
    {
      text: 'Boleto',
      imgurl: imageUrl('Boleto_BR'),
      paymentType: 'Boleto'
    },
    {
      text: 'Boleto fast',
      imgurl: imageUrl('Boleto_fast_BR'),
      paymentType: 'Boletofast'
    },
    {
      text: 'Lottery_BR.png',
      imgurl: imageUrl('Lottery_BR'),
      paymentType: 'LOTTERY'
    },
    {
      text: 'MercadoPago',
      imgurl: imageUrl('Mercado_Pago_BR'),
      paymentType: 'MERCADOPAGO'
    },
    {
      text: 'Ame',
      imgurl: imageUrl('Ame_BR'),
      paymentType: 'AME'
    },
    {
      text: 'PicPay',
      imgurl: imageUrl('PicPay_BR'),
      paymentType: 'PICPAY'
    }
    // { text: "PagSeguro", imgurl: imageUrl('PagSeguro_BR'), paymentType: 'PAGSEGURO' },
  ],
  MX: [
    {
      text: 'Debit/Credit Card',
      imgurl: imageUrl('B0_Card'),
      paymentType: '20'
    },
    {
      text: 'Bank Transfer',
      imgurl: imageUrl('C0_Bank_Transfer'),
      paymentType: '03'
    },
    // { text: "SPEI", imgurl: imageUrl('SPEI_MX'), paymentType: 'SPEI' },
    // { text: "BBVA Bancomer", imgurl: imageUrl('BBVA_PE'), paymentType: 'BBVA' },
    // { text: "Banorte", imgurl: imageUrl('Banorte_MX'), paymentType: 'Banorte' },
    // { text: "Santander", imgurl: imageUrl('Santander_MX'), paymentType: 'Santander' },
    {
      text: 'OXXO',
      imgurl: imageUrl('OXXO_MX'),
      paymentType: 'OXXO'
    }
  ],
  CO: [
    {
      text: 'Debit/Credit Card',
      imgurl: imageUrl('B0_Card'),
      paymentType: '20'
    },
    {
      text: 'PSE',
      imgurl: imageUrl('PSE_CO'),
      paymentType: '03'
    },
    // { text: "OTC STORE", imgurl: imageUrl('E0_OTC_Store'), paymentType: 'A50' },
    {
      text: 'Efecty',
      imgurl: imageUrl('Efecty_CO'),
      paymentType: 'Efecty'
    },
    {
      text: 'Davivienda',
      imgurl: imageUrl('Davivienda_CO'),
      paymentType: 'Davivienda'
    },
    {
      text: 'Baloto',
      imgurl: imageUrl('Baloto_CO'),
      paymentType: 'Baloto'
    }
  ],
  PE: [
    {
      text: 'Debit/Credit Card',
      imgurl: imageUrl('B0_Card'),
      paymentType: '20'
    },
    {
      text: 'Bank Transfer',
      imgurl: imageUrl('C0_Bank_Transfer'),
      paymentType: '03'
    },
    // { text: "BCP", imgurl: imageUrl('BCP_PE'), paymentType: 'BCP' },
    // { text: "Interbank", imgurl: imageUrl('Interbank_PE'), paymentType: 'Interbank' },
    // { text: "BBVA", imgurl: imageUrl('BBVA_PE'), paymentType: 'BBVA' },
    {
      text: 'Pago Efectivo',
      imgurl: imageUrl('Pago_Efectivo_PE'),
      paymentType: 'PagoEfectivo'
    }
  ],
  CL: [
    {
      text: 'Credit Card',
      imgurl: imageUrl('B1_Credit_Card'),
      paymentType: '20'
    },
    {
      text: 'WebPay',
      imgurl: imageUrl('WebPay_CL'),
      paymentType: '03'
    },
    {
      text: 'Servipag',
      imgurl: imageUrl('Servipag_CL'),
      paymentType: 'Servipag'
    }
  ],
  UY: [
    {
      text: 'Credit Card',
      imgurl: imageUrl('B1_Credit_Card'),
      paymentType: '20'
    },
    {
      text: 'OTC STORE',
      imgurl: imageUrl('E0_OTC_Store'),
      paymentType: 'A50'
    }
    // { text: "Red Pagos", imgurl: imageUrl('Red_Pagos_UY'), paymentType: 'RedPagos' },
    // { text: "Abitab", imgurl: imageUrl('Abitab_UY'), paymentType: 'Abitab' },
  ],
  PY: [
    {
      text: 'Credit Card',
      imgurl: imageUrl('B1_Credit_Card'),
      paymentType: '20'
    }
    // { text: "PagoExpress", imgurl: imageUrl('PagoExpress_PY'), paymentType: 'PagoExpress' },
  ],
  AR: [
    {
      text: 'Credit Card',
      imgurl: imageUrl('B1_Credit_Card'),
      paymentType: '20'
    },
    {
      text: 'Bank Transfer',
      imgurl: imageUrl('C0_Bank_Transfer'),
      paymentType: '03'
    },
    {
      text: 'Pago Fácil',
      imgurl: imageUrl('Pago_Facil_AR'),
      paymentType: 'PAGOFACIL'
    },
    {
      text: 'Rapi Pago',
      imgurl: imageUrl('Rapi_Pago_AR'),
      paymentType: 'RAPIPAGO'
    }
  ],
  US: [
    {
      text: 'Visa/MasterCard',
      imgurl: imageUrl('B0_Card'),
      paymentType: 'A34'
    }
  ],
  IQ: [
    {
      text: 'Visa/MasterCard',
      imgurl: imageUrl('B0_Card'),
      paymentType: 'A34'
    }
  ]
}
